(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const productEl = document.querySelector('#product');
    const sectionId = productEl.dataset.sectionId;
    const optionValueSelectors = productEl.querySelector('.optionValueSelectors');
    const priceEl = document.querySelector(`#ProductPrice-${sectionId}`);
    const variantInput = document.querySelector(`#VariantIdInput-${sectionId}`);
    const form = document.querySelector(`#AddToCartForm-${sectionId}`);
    const qtyInput = document.querySelector(`#Quantity-${sectionId}`);
    const addToCartBtn = form.querySelector('.add-to-cart');

    // Toggle Add to Cart based on inventory
    function toggleAddToCartButton(inventory) {
      if (inventory > 0) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Out of Stock';
      }
    }

    // First load: check inventory
    toggleAddToCartButton(parseInt(variantInput.dataset.inventory));

    // Update Selected Option Display (Color — Black)
    function updateSelectedOptionDisplay(input) {
      const optionName = input.dataset.optionName;
      const value = input.value;
      const displayEl = document.querySelector(`#SelectedOption-${optionName.toLowerCase().replace(/\s+/g, '-')}`);
      if (displayEl) {
        displayEl.textContent = `${optionName} — ${value}`;
      }
    }

    optionValueSelectors.addEventListener('change', async (event) => {
      const input = event.target;
      if (!input.matches('input[type="radio"]')) return;

      updateSelectedOptionDisplay(input);

      const newProductUrl = input.dataset.productUrl;
      const selectedOptionValues = Array.from(optionValueSelectors.querySelectorAll('fieldset input:checked')).map(
        ({ dataset }) => dataset.optionValueId
      );

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      const res = await fetch(`${newProductUrl}?section_id=${sectionId}${params}`);
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');

      const newPrice = html.querySelector(`#ProductPrice-${sectionId}`)?.innerHTML;
      const newVariantInput = html.querySelector(`#VariantIdInput-${sectionId}`);

      if (newPrice) priceEl.innerHTML = newPrice;

      if (newVariantInput) {
        variantInput.value = newVariantInput.value;
        variantInput.dataset.inventory = newVariantInput.dataset.inventory;

        const url = new URL(window.location);
        url.searchParams.set('variant', newVariantInput.value);
        window.history.replaceState({}, '', url);

        // 🔥 Update button based on inventory
        toggleAddToCartButton(parseInt(newVariantInput.dataset.inventory));
      }
    });

    // Add to Cart
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = variantInput.value;
      const quantity = parseInt(qtyInput.value, 10) || 1;

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
      });

      if (res.ok) {
        window.location.href = '/cart';
      } else {
        alert('Error adding to cart');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
